export default __webpack_public_path__ + "static/media/side_doodle.fe8a1c11.jpg";